<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="券名称">
          <el-input placeholder="请输入券名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加券</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table 
            size="small" 
            :data="tableData" 
            border 
            style="width: 100%" 
            v-loading="loading" 
            @selection-change="handleSelectionChange"
            ref="multipleTable"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="name" label="券名称"></el-table-column>
            <el-table-column prop="unit_price" label="单价" :formatter="formatPrice"></el-table-column>
            <el-table-column prop="denomination" label="面额"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
            <el-table-column prop="class_hours" label="课时"></el-table-column>
            <el-table-column prop="sy_num" label="剩余数量"></el-table-column>
            <el-table-column prop="voucher_type_name" label="类型"></el-table-column>
            <el-table-column prop="ma_organization_name" label="组织"></el-table-column>
            <el-table-column prop="area" label="所属地区"></el-table-column>
            <el-table-column prop="range" label="适用范围"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <!-- <el-button @click="buyClick(scope.row)" type="text" size="small" icon="el-icon-shopping-cart-2">购买</el-button> -->
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :voucher_id="voucher_id" v-if="open_edit" @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>

    <!-- 购买弹窗 -->
    <el-dialog 
      title="购买券" 
      :visible.sync="buyDialogVisible" 
      :close-on-click-modal="false"
      :close-on-press-escape="false" 
      width="500px"
      @close="closeBuyDialog"
    >
      <el-form 
        size="small" 
        :model="buyForm" 
        ref="buyForm" 
        :rules="buyRules" 
        label-width="100px"
        style="padding-bottom: 60px;"
      >
        <el-form-item label="券名称" prop="name">
          <el-input 
            v-model="buyForm.name" 
            placeholder="券名称" 
            readonly
            :disabled="true"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="单价" prop="unit_price_display">
          <el-input 
            v-model="buyForm.unit_price_display" 
            placeholder="单价" 
            readonly
            :disabled="true"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="面额" prop="denomination">
          <el-input 
            v-model="buyForm.denomination" 
            placeholder="面额" 
            readonly
            :disabled="true"
            style="width: 100%;"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        
        <el-form-item label="剩余数量" prop="remaining_num">
          <el-input 
            v-model="buyForm.remaining_num" 
            placeholder="剩余数量" 
            readonly
            :disabled="true"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="组织" prop="ma_organization_id">
          <el-select 
            v-model="buyForm.ma_organization_id" 
            placeholder="请选择组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in maOrganizationList"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="绑定用户" prop="user_id" required>
          <div class="d-s-s d-c">
            <el-button @click="openGetuser"  icon="el-icon-plus">选择会员</el-button>
            <div class="d-s-s" v-if="buyForm.user">
                <img :src="buyForm.user.avatarUrl" class="radius" width="30" height="30" />
            </div>
            <div class="d-s-s" v-if="buyForm.user">
                 <p class="lh18 ww100 text-ellipsis">用户昵称：{{buyForm.user.nickName}}</p>

            </div>
            <div class="d-s-s"  v-if="buyForm.user">
                <p class="lh18 ww100 text-ellipsis">手机号：{{buyForm.user.mobile}}</p>
            </div>
            <div v-if="buyForm.user_id === '' && buyForm.user_id !== 0" style="color: #F56C6C; font-size: 12px; margin-top: 5px;">
              请选择绑定用户
            </div>
          </div>
        </el-form-item>
        <el-form-item label="购买数量" prop="buy_num">
          <el-input-number 
            v-model="buyForm.buy_num" 
            placeholder="请输入购买数量" 
            :min="1"
            :max="buyForm.max_buy_num || 99999"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
          <div class="el-form-item__tips" v-if="buyForm.remaining_num">
            最大可购买数量: {{ buyForm.max_buy_num }}
          </div>
        </el-form-item>
        
        <el-form-item label="总金额" prop="total_amount">
          <el-input 
            v-model="buyForm.total_amount" 
            placeholder="总金额" 
            readonly
            style="width: 100%;"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        
        <div class="common-button-wrapper" style="text-align: center; margin-top: 30px;">
          <el-button size="small" type="info" @click="cancelBuy">取消</el-button>
          <el-button size="small" type="primary" @click="confirmBuy" :loading="buyLoading">确认购买</el-button>
        </div>
      </el-form>
    </el-dialog>
    
    <el-dialog  
      style="text-align: center" 
      title="设置标题" 
      :visible.sync="dialogVisible" 
      @close='dialogFormVisible'
      :close-on-click-modal="false"
      :close-on-press-escape="false" 
      :append-to-body="true"
    ></el-dialog>
  </div>
</template>

<script>
import VoucherApi from '@/api/voucher.js';
import AfuncApi from '@/api/afunc.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';
import GetUser from '@/components/user/GetUser.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
    GetUser
  },
  inject: ['reload'],
  data() {
    return {
      maOrganizationList: [],
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      voucher_id: "",
      dialogVisible: false,
      open_import: false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
      
      /* 购买相关 */
      buyDialogVisible: false,
      buyLoading: false,
      currentVoucher: null,
      buyForm: {
        voucher_id: '',
        name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        buy_num: 1,
        max_buy_num: 0,
        total_amount: '0.00',
        unit_price: '',
        unit_price_unit: '',
        ma_organization_id:'',
        user_id: '', 
        user: null
      },
      open_getuser:false,
      buyRules: {
        buy_num: [
          { required: true, message: '请输入购买数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '购买数量至少为1', trigger: 'blur' }
        ],
        ma_organization_id: [
          { required: true, message: '请选择组织', trigger: 'blur' }
        ],
        user_id: [
          { required: true, message: '请选择绑定用户', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
    this.loadOrganization();
  },
  watch: {
    'buyForm.buy_num': function(newVal) {
      this.calculateTotalAmount();
    },
    'buyForm.remaining_num': function(newVal) {
      if (newVal) {
        const num = parseInt(newVal);
        this.buyForm.max_buy_num = num;
        // 如果当前购买数量大于最大可购买数量，调整为最大数量
        if (this.buyForm.buy_num > num) {
          this.buyForm.buy_num = num;
        }
      }
    }
  },
  methods: {
    openGetuser() {
      this.open_getuser = true;
    },
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.buyForm.user=e.params[0];
        this.buyForm.user_id=e.params[0].user_id;
      }
      this.open_getuser = false;
    },
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.maOrganizationList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.maOrganizationList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.maOrganizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.maOrganizationList = [];
      }
    },
    /* 计算总金额 */
    calculateTotalAmount() {
      if (!this.buyForm.unit_price || !this.buyForm.buy_num) {
        this.buyForm.total_amount = '0.00';
        return;
      }
      
      // 确保 unit_price 是数字类型
      const unitPrice = parseFloat(this.buyForm.unit_price) || 0;
      const buyNum = parseInt(this.buyForm.buy_num) || 0;
      const total = unitPrice * buyNum;
      
      // 保留两位小数
      this.buyForm.total_amount = total.toFixed(2);
    },
    
    /* 购买点击 */
    buyClick(row) {
      // 单位映射
      const unitMap = {
        0: '元/人次',
        1: '元/学时',
        2: '元/课时'
      };
      
      this.currentVoucher = row;
      
      // 确保 unit_price 是数字类型
      const unitPrice = parseFloat(row.unit_price) || 0;
      const remainingNum = parseInt(row.sy_num || row.num) || 0;
      
      this.buyForm = {
        voucher_id: row.voucher_id,
        name: row.name,
        unit_price_display: `${unitPrice} ${unitMap[row.unit_price_unit] || unitMap[0]}`,
        denomination: row.denomination || '0',
        remaining_num: remainingNum,
        buy_num: 1,
        max_buy_num: remainingNum,
        total_amount: unitPrice.toFixed(2),
        unit_price: unitPrice,
        unit_price_unit: row.unit_price_unit,
      };
      
      this.buyDialogVisible = true;
    },
    
    /* 关闭购买弹窗 */
    closeBuyDialog() {
      this.buyForm = {
        voucher_id: '',
        name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        buy_num: 1,
        max_buy_num: 0,
        total_amount: '0.00',
        ma_organization_id:'',
        unit_price: '',
        unit_price_unit: '',
        user_id: '',  
        user: null  
      };
      this.currentVoucher = null;
      this.$refs.buyForm && this.$refs.buyForm.clearValidate();
    },
    
    /* 取消购买 */
    cancelBuy() {
      this.buyDialogVisible = false;
    },
    
    /* 确认购买 */
    confirmBuy() {
      this.$refs.buyForm.validate(valid => {
        if (valid) {
          // 验证购买数量是否超过剩余数量
          if (this.buyForm.buy_num > this.buyForm.max_buy_num) {
            this.$message.error(`购买数量不能超过剩余数量(${this.buyForm.max_buy_num})`);
            return;
          }
          
          this.$confirm(`确定要购买 ${this.buyForm.buy_num} 张 "${this.buyForm.name}" 券吗？`, '确认购买', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.executeBuy();
          }).catch(() => {
            // 用户取消
          });
        }
      });
    },
    
    /* 执行购买操作 */
    executeBuy() {
      this.buyLoading = true;
      
      const buyNum = parseInt(this.buyForm.buy_num);
      const maOrganizationId = this.buyForm.ma_organization_id;
      const userId = this.buyForm.user_id;
      
      if (!userId) {
        this.$message.error('请选择绑定用户');
        this.buyLoading = false;
        return;
      }
      if (!maOrganizationId) {
        this.$message.error('请选择组织');
        this.buyLoading = false;
        return;
      }
      
      if (isNaN(buyNum) || buyNum <= 0) {
        this.$message.error('购买数量无效');
        this.buyLoading = false;
        return;
      }
      
      const buyData = {
        voucher_id: this.buyForm.voucher_id,
        buy_num: buyNum,
        total_amount: this.buyForm.total_amount,
        ma_organization_id: maOrganizationId,
        user_id: userId,
      };
      
      // 调用购买API
      VoucherApi.buy(buyData, true)
        .then(data => {
          this.buyLoading = false;
          if (data.code === 1) {
            this.$message({
              message: data.msg || '购买成功',
              type: 'success'
            });
            this.buyDialogVisible = false;
            // 刷新列表
            this.getTableList();
          } else {
            this.$message.error(data.msg || '购买失败');
          }
        })
        .catch(error => {
          this.buyLoading = false;
        });
    },
    
    formatPrice(row, column, cellValue) {
      const unitMap = {
        0: '元/人次',
        1: '元/学时',
        2: '元/课时'
      };
      
      // 确保 unit_price 是数字类型
      const unitPrice = parseFloat(row.unit_price) || 0;
      const unitPriceUnit = parseInt(row.unit_price_unit) || 0;
      
      return `${unitPrice} ${unitMap[unitPriceUnit] || '未知单位'}`;
    },
    
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    
    setting(e) {
      this.dialogVisible = true;
    },
    
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    
    /* 清空选择 */
    clearSelection() {
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    
    importClick() {
      this.open_import = true;
    },
    
    exportData() {
      // 构建导出参数
      let exportParams = {
        name: this.formInline.name,
      };

      // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.voucher_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      // 使用页面跳转方式导出，避免blob处理
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
        .filter(key => exportParams[key] !== '')
        .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
        .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.voucher.Index/export?' + queryString;
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      VoucherApi.list(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code === 1 && data.data && data.data.list) {
            self.tableData = data.data.list.data || [];
            self.totalDataNumber = data.data.list.total || 0;
            
            // 处理数据，确保数字字段是正确类型
            self.tableData = self.tableData.map(item => {
              return {
                ...item,
                unit_price: parseFloat(item.unit_price) || 0,
                denomination: parseFloat(item.denomination) || 0,
                num: parseInt(item.num) || 0,
                sy_num: parseInt(item.sy_num || item.num) || 0,
                unit_price_unit: parseInt(item.unit_price_unit) || 0,
                sort: parseInt(item.sort) || 50,
              };
            });
          } else {
            self.tableData = [];
            self.totalDataNumber = 0;
          }
        })
        .catch(error => {
          self.loading = false;
          self.tableData = [];
          self.totalDataNumber = 0;
          console.error('获取列表失败:', error);
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.voucher_id = row.voucher_id;
      this.open_edit = true
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          VoucherApi.del(
            {
              voucher_id: row.voucher_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getTableList();
              } else {
                self.$message.error(data.msg || '删除失败');
              }
            })
            .catch(error => {
              self.$message.error('删除失败');
            });
        })
        .catch(() => {
        });
    }
  }
};
</script>

<style scoped>
.el-form-item__tips {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.common-button-wrapper {
  text-align: center;
}

/* 操作按钮间距调整 */
.el-table .cell .el-button {
  margin-right: 5px;
}

.el-table .cell .el-button:last-child {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/voucher/index/index.vue